export default __webpack_public_path__ + "static/media/04_kitty.3ba6fe30.JPG";